export default __webpack_public_path__ + "static/freight-big-pro-black-f148157341ca4b2074261ec11958bf91.woff";